import axios from "axios";
import { Indicator } from 'mint-ui';
export default({
    state:{
        pager:{PageIndex:1,PageSize:5,PageTotal:0},
        informationText:[]
    },
    mutations:{
        informationData(state,pageIndex=1){
            state.pager.PageIndex=pageIndex;
            Indicator.open('');  
            var params = new URLSearchParams()
            params.append('pageSize',state.pager.PageSize)
            params.append('pageIndex',pageIndex)
            axios.post('http://website.xiaoyu168.com/Public/PageTradePress',params,{ headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }}).then(d=>{
                console.log(d.data)
                if(d&&d.data){ 
                    Indicator.close();
                   // console.log(d.data)
                    state.informationText=d.data.Rows.map(item=>{
                       var data=new Date(parseInt(item.AddTime.replace(/[^0-9]/ig, '')))
                        item.AddTime=data.format("yyyy-MM-dd")

                        return item
                    })
                    state.pager.PageSize=d.data.Pager.PageSize;
                    state.pager.PageTotal=d.data.Pager.PageTotal 
                //   console.log( state.pager.PageTotal) 
                }
            })
            

        }
    }
    




})


// WEBPACK FOOTER //
// ./src/store/information/index.js